import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

const SemanticTableDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  record,
  isDeleting = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          bgcolor: 'var(--wb-bg-panel)',
          color: 'var(--wb-text-strong)',
          borderRadius: 2
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid var(--wb-overlay-10)' }}>
        Confirmar eliminación lógica
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Typography variant="body1" sx={{ color: 'var(--wb-text)' }}>
          ¿Deseas marcar como eliminada la entidad&nbsp;
          <strong>{record?.display_name || record?.table_name || record?.table_id}</strong>?<br />
          Podrás revertirla editando la entidad y desactivando el borrado lógico.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ borderTop: '1px solid var(--wb-overlay-10)' }}>
        <Button onClick={onClose} disabled={isDeleting} sx={{ color: 'var(--wb-muted)' }}>
          Cancelar
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={isDeleting}
          sx={{
            bgcolor: 'var(--wb-x-bg-ef4444, #ef4444)',
            '&:hover': { bgcolor: 'var(--wb-x-bg-dc2626, #dc2626)' }
          }}
        >
          {isDeleting ? 'Eliminando…' : 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SemanticTableDeleteDialog;
